import React, { memo } from 'react'
import clsx from 'clsx'
import Image from 'next/image'
import ButtonBase from '@mui/material/ButtonBase'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import usePageProps from 'hooks/usePageProps'
import sx from './styles'

const CategoryFilterCard = ({ item, onChange, selected = false }) => {
  const { locale } = usePageProps()

  return (
    <Box
      sx={sx.container}
    >
      <ButtonBase
        sx={sx.root}
        className={clsx({
          selected,
        })}
        onClick={() => onChange(item?.slug)}
      >
        <Box
          sx={sx.iconContainer}
          className="Icon-container"
        >
          <Image
            src={item?.icon}
            alt={item?.name}
            layout="fill"
            objectFit="contain"
            unoptimized
          />
        </Box>
        <Box>
          <Typography variant="caption">
            {locale === 'es' ? item?.name_es : item?.name_en}
          </Typography>
        </Box>
      </ButtonBase>
    </Box>
  )
}

export default memo(CategoryFilterCard)
